/**
 * What the intake file picker offers, as an `accept` list.
 *
 * Kept at least as narrow as workspace-api's `AGENTIC_ATTACHMENT_POLICY`. A file type the policy
 * omits is not withheld and skipped like one the model cannot read: it throws and takes the whole
 * generation with it, so the asymmetry has to run this way round. Rejecting the rest in the picker
 * also turns a minute-long failed generation into immediate feedback.
 */
export const BRIEF_INTAKE_ACCEPTED_FORMATS = [
  'image/*',
  'video/*',
  '.pdf',
  '.txt',
  '.md',
  '.csv',
  '.docx',
  '.doc',
  '.pptx',
  '.ppt',
  '.xlsx',
  '.xls',
].join(',');
